export default {
  title: '与客户对话',
  userId: '用户ID',
  nick: '用户昵称',
  chatCreation: '对话发起时间',
  orderSerial: '订单序号',
  orderDate: '订单时间',
  paymentType: '支付方式',
  amount: '金额',
  orderNo: '订单编号',
  orderTime: '下单时间',
  total: '金额',
  item: '商品数',
  receiverInformation: '收货人信息',
  name: '姓名',
  phone: '电话',
  addres: '地址',
  remarks: '用户备注',
  confirmTime: '确认时间',
  userConfirmed: '用户已确认',
  userUnconfirmed: '用户未确认',
  shipOrderNo: '发运单编号',
  placeholder1: '请输入内容...',
  send: '发送',
  clear: '清空',
  reply: '快捷回复',
  fastreply1: 'Welcome to our store. Please feel free to ask any question.',
  fastreply2: 'Sorry about the late. The order is for global product and it will take about 15-30 workdays to arrive in Dhaka. Please wait. You can track the order in the order detail anytime.',
  fastreply3: 'Yes we have it in stock, please add it to cart and check out. You will receive the item in a few days.',
  fastreply4: 'We are sorry that we don\'t have the product in stock. Would you like to cancel the order?',
  fastreply5: 'Sorry we can\'t cancel the order as it has already been dispatched and will arrive in Dhaka soon. Would you please wait a bit longer and we are sure you will receive it in shortest time.',
  contentListServer: 'ulvinar sodales ut in libero. Sed lobortis vitae est sit amet sodales.',
  pamentType1: '在线支付',
  pamentType2: '货到付款',
  pamentType3: '积分抵扣',
  pamentType4: '优惠券抵扣',
  // =====================新增============2021/3/8
  newAfterRequest: '用户发起了新的售后请求，请尽快处理',
  afterSaleID: '售后申请ID',
  orderNum: '关联订单号',
  user: '用户',
  afterSaleRequest: '售后请求',
  afterSaleMethod1: '换货',
  afterSaleMethod2: '退货并退款',
  afterSaleMethod3: '维修',
  afterSaleMethod4: '退款',
  afterSaleMethod5: '补发'
}
